"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _cmsDesignComponent = require("@tencent/cms-design-component");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatQuickstarts = (properties, options = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const configuration = [];
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$list = properties.list,
    list = _properties$list === void 0 ? [] : _properties$list; // 第一条数据是模块名称
  for (let i = 0; i < list.length; i++) {
    // 目前选项卡组件最大只支持3个tab
    const _list$i = list[i],
      title = _list$i.title,
      content = _list$i.content; // 默认为''
    if (title || content) {
      const itemData = {
        key: `${i + 1}`,
        title,
        content: formatUrlInText(content || '', {
          reportEvent: 'click_quickstarts_richtext_href'
        })
      };
      configuration.push(itemData);
    }
  }
  return {
    modTitle,
    configuration,
    bgColor: color
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  const componentData = data;
  if (componentData) {
    const _formatQuickstarts = formatQuickstarts(componentData, {
        domains
      }),
      _formatQuickstarts$co = _formatQuickstarts.configuration,
      configuration = _formatQuickstarts$co === void 0 ? [] : _formatQuickstarts$co,
      _formatQuickstarts$mo = _formatQuickstarts.modTitle,
      modTitle = _formatQuickstarts$mo === void 0 ? '' : _formatQuickstarts$mo,
      _formatQuickstarts$bg = _formatQuickstarts.bgColor,
      bgColor = _formatQuickstarts$bg === void 0 ? '' : _formatQuickstarts$bg;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_quickStarts', componentKey, modTitle])), /*#__PURE__*/React.createElement(_cmsDesignComponent.QuickStarts, {
      configuration: configuration,
      flexTitle: modTitle,
      style: bgStyle
    }));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
}